<i18n src="@/lang/actions.json"></i18n>
<i18n>
    {
        "en": {
            "start": "Start from",
            "end": "Expire after",
            "table_actions": "Actions"
        },
        "ua": {
            "start": "Діє з",
            "end": "Не діє після",
            "table_actions": "Дії"
        },
        "ru": {
            "start": "Действует с",
            "end": "Не действует послуе",
            "table_actions": "Действия"
        }
    }
</i18n>

<template>
  <div>
    <el-header class="actions">
      <el-row type="flex" class="row-bg" justify="end">
        <el-button-group>
          <el-button
            type="primary"
            v-text="$t('actions.new_period')"
            :disabled="cur_edited_index != -1"
            @click="handleAddNew"
          />
        </el-button-group>
      </el-row>
    </el-header>
    <el-table :data="s_periods">
      <el-table-column :label="$t('start')" prop="date_start">
        <template slot-scope="scope">
          <template v-if="scope.$index != cur_edited_index">
            {{ scope.row.date_start }}
          </template>
          <template v-if="scope.$index == cur_edited_index">
            <el-date-picker
              v-model="scope.row.date_start"
              value-format="dd-MM-yyyy"
              format="dd-MM-yyyy"
              type="date"
              _placeholder="Pick a day"
              :style="{ width: '135px' }"
            />
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('end')" prop="date_end">
        <template slot-scope="scope">
          <template v-if="scope.$index != cur_edited_index">
            {{ scope.row.date_end }}
          </template>
          <template v-if="scope.$index == cur_edited_index">
            <el-select
              v-model="scope.row.date_end"
              placeholder="please select period"
            >
              <el-option
                v-for="p in periods_templates"
                :key="scope.$index + p.name + p.value"
                :label="p.name"
                :value="p.value"
              />
            </el-select>
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table_actions')" align="right">
        <template slot-scope="scope">
          <template v-if="scope.$index != cur_edited_index">
            <el-button
              type="text"
              size="small"
              :disabled="cur_edited_index != -1"
              v-text="$t('actions.delete')"
              @click="
                () => {
                  $confirm('Realy want to delete?')
                    .then(() => {
                      s_periods = s_periods.filter((v, i) => i != scope.$index);
                      $emit('update:sharedPeriods', s_periods);
                      $emit('savePeriods');
                    })
                    .catch(() => {});
                }
              "
            />
          </template>
          <template v-if="scope.$index == cur_edited_index">
            <el-button
              @click="handleSave(scope)"
              type="text"
              size="small"
              :disabled="!scope.row.date_start || !scope.row.date_end"
              v-text="$t('actions.save')"
            />
            <el-button
              type="text"
              size="small"
              @click="
                () => {
                  s_periods = s_periods.filter((v, i) => i != scope.$index);
                  cur_edited_index = -1;
                }
              "
              v-text="$t('actions.cancel')"
            />
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import DirectoryPeriods from "../../../store/classes/DirectoryPeriods";
import Period from "../../../store/classes/subClasses/Period";

export default {
  name: "periods_tab_content",
  props: {
    sharedPeriods: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      s_periods: this.sharedPeriods,
      new_period: null,
      get new_period_template() {
        return new DirectoryPeriods({
          // "date_start": (new Date()),
          date_start: new Date()
            .toISOString()
            .split("T")[0]
            .split("-")
            .reverse()
            .join("-"),
          date_end: "",
          period: ""
        });
      },
      cur_edited_index: -1
    };
  },
  created() {
    if (!this.periods_templates.length) {
      this.getPeriodsTemplates();
    }
  },
  watch: {
    sharedPeriods(v) {
      this.s_periods = v;
    }
  },
  methods: {
    handleAddNew() {
      this.s_periods.unshift(
        new Period(Object.assign({}, this.new_period_template))
      );
      this.cur_edited_index = 0;
    },
    handleSave() {
      let p = this.s_periods[this.cur_edited_index];
      let tmp = p.date_end;
      let t = p.date_end.split(" ");
      let number = t[0].match(/\d+/g)[0] * 1;
      let key = t[1] + (t[1].endsWith("s") ? "" : "s");
      p.period = p.date_end;
      p.date_end = moment(p.date_start, "DD-MM-YYYY")
        .add(number, key)
        .format("DD-MM-YYYY");

      let crosses = this.validatePeriod();
      if (crosses.length != 0) {
        this.$confirm(
          "<span>" + crosses.map(v => v.asString).join("<br>") + "</span>",
          "Cross preiods",
          { dangerouslyUseHTMLString: true }
        )
          .then(() => {
            this.savePeriods();
          })
          .catch(() => {
            this.$log("validator FALSE");
            p.date_end = tmp;
          });
        return;
      }

      this.savePeriods();
    },
    savePeriods() {
      this.cur_edited_index = -1;
      this.$emit("update:sharedPeriods", this.s_periods);
      this.$emit("savePeriods");
    },
    validatePeriod() {
      let crosses = this.s_periods.filter(
        (v, i) =>
          i != this.cur_edited_index &&
          v.dateHaveCrossWith(this.s_periods[this.cur_edited_index])
      );
      this.$log("crosses", crosses);
      return crosses;
    },
    getPeriodsTemplates() {
      this.$api
        .query({
          query: require("../../../graphql/periods/periods_list.graphql")
        })
        .then(res => {
          this.$log(res);
          this.$store.commit("periods/setData", res.data.periods);
        });
    }
  },
  computed: {
    ...mapState({
      periods_templates: state => state.directory_periods_list.data
    })
  }
};
</script>

<style scoped></style>
